/**
 *
 * */
define('modules/typeahead',[
    'domReady',
    'underscore',
    'jquery',
    'utils/declOfNum',
    'modules/typeahead.jquery'
], function(domReady, _, $, declOfNum) {
    'use strict';

    console.log('%cfile: typeahead.js', 'color: #C2ECFF');

    var defaults = {
            elements: {
                'el': '[data-typeahead]',
                'link': '[data-cities-link]',
                'count': '[data-cities-count]',
                'value': '[data-cities-value]'
            },
            $elements: {}
        },

        substringMatcher,
        dataObjects = {},
        dataObjectsCount = {};

    function Module() {
        console.log('%ctrace: module typehead: module()', 'color: #ccc');

        domReady(function () {
            console.log('%ctrace: module typehead: module() -> domReady', 'color: #ccc');

            domElementsUpdates();

            getData(function(data) {
                var citiesList = getCities(data);

                initialize(citiesList);
            });

            getIp(function(data) {
                updateCityFromIp(data);
            });

            $('body').on('click', defaults.elements.link, function(event) {
                updateLink($(this));
            });

            $('.typeahead').on('typeahead:close', function(event) {
                var value = defaults.$elements.el.val();

                if (Object.keys(dataObjectsCount).length > 0 && dataObjectsCount[value]) {
                    defaults.$elements.count.html(dataObjectsCount[value]);
                    declOfNum();
                }

                updateLink(defaults.$elements.link);
            });
        });
    }

    function initialize (data) {
        defaults.$elements.el.typeahead({
            hint: true,
            highlight: true,
            minLength: 1
        }, {
            name: 'cities',
            source: substringMatcher(data)
        });
    }

    function updateLink ($el) {
        var link = $el.attr('data-cities-link'),
            value = defaults.$elements.el.val();

        if (Object.keys(dataObjects).length > 0 && dataObjects[value]) {
            link = link + '#city/' + dataObjects[value];
        }

        $el.attr('href', link);
    }

    function getData (cb) {
        $.ajax({
            url: '/json/data.json'
        }).done(function(data) {
            cb(data);
        });
    }

    function getIp (cb) {
        window.ymaps.ready(function () {
            window.ymaps.geolocation.get({
                provider: 'yandex',
                autoReverseGeocode: true
            }).then(function (result) {
                var data = {};
                data.city = result.geoObjects.get(0).properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName');

                console.log(result, data);

                cb(data);
            });
        });
    }

    function updateCityFromIp (data) {
        if (!data.city) {
            return false;
        }

        var value = 'г. ' + data.city;

        $('.typeahead').typeahead('val', value);

        if (Object.keys(dataObjectsCount).length > 0 && dataObjectsCount[value]) {
            defaults.$elements.count.html(dataObjectsCount[value]);
            declOfNum();
        }

        updateLink(defaults.$elements.link);
    }

    function getCities (data, currentCity) {
        currentCity = currentCity || false;
        var response = [];

        _.each(data.features, function(object) {
            if (object.properties.ifPromoParticipate) {
                response.push(object.properties.city);
                dataObjects[object.properties.city] = object.properties.id;

                if (!dataObjectsCount[object.properties.city]) {
                    dataObjectsCount[object.properties.city] = 0;
                }

                dataObjectsCount[object.properties.city]++;
            }
        });

        response = _.uniq(response);

        return response;
    }

    function domElementsUpdates (){
        console.log('%ctrace: ImageSlider -> domElementsUpdates', 'color: #ccc');

        _.forEach(defaults.elements, function(value, key){
            defaults.$elements[key] = $(value);
        });
    }

    substringMatcher = function substringMatcher(strs) {
        return function findMatches(q, cb) {
            var matches, substringRegex;

            // an array that will be populated with substring matches
            matches = [];

            // regex used to determine if a string contains the substring `q`
            substringRegex = new RegExp(q, 'i');

            // iterate through the pool of strings and for any string that
            // contains the substring `q`, add it to the `matches` array
            $.each(strs, function(i, str) {
                if (substringRegex.test(str)) {
                    matches.push(str);
                }
            });

            cb(matches);
        };
    };

    return Module;
});

